<template>
    <div class="d-inline-block">
        <div class="d-inline-flex align-items-center">
            <strong class="line-height-unset price-incl-switch">Prijzen incl BTW</strong>
            <label class="tax-switch mb-0 ml-2">
                <input type="checkbox"
                       v-model="priceIncludingTax"
                       @change="setPriceTaxCookie(priceIncludingTax)"
                >
                <span class="slider"></span>
            </label>
        </div>
    </div>
</template>

<script>
    import PriceViewMixin from './PriceViewMixin';

    export default {
        mixins: [ PriceViewMixin ]
    }
</script>
